<main class="public-page">
  <menu-portale></menu-portale>

  <section class="public-hero">
    <p class="public-hero__eyebrow">Assistenza</p>
    <h1>Contattaci</h1>
    <p>Scrivici: il nostro team è qui per aiutarti.</p>
  </section>

  <section class="portale-section">
    <form class="content-card public-form" [formGroup]="form">
      <mat-form-field>
      <mat-label>Nome</mat-label>
      <input matInput formControlName="subject">
    </mat-form-field>

      <mat-form-field>
      <mat-label>E-mail</mat-label>
      <input matInput formControlName="from" type="email">
    </mat-form-field>

      <mat-form-field>
      <mat-label>Testo</mat-label>
      <textarea matInput formControlName="message"></textarea>
      <mat-hint>Lunghezza massima: 350 caratteri</mat-hint>
    </mat-form-field>

      <div>
      <mat-checkbox formControlName="accepted">
        Ho letto l'informativa ed acconsento all'utilizzo dei miei dati personali per i fini specificati nella stessa
      </mat-checkbox>
      </div>

      <div class="public-form__actions">
      <button mat-raised-button color="primary" [disabled]="!form.valid" (click)="invia()">Invia dati</button>
      </div>
    </form>
  </section>

  <app-portale-layout-footer></app-portale-layout-footer>
</main>
